import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import Shimmer from "react-shimmer-effect";
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import { accessRole } from "../../../../helpers/access_role"
import CustomSelect from '../../../../helpers/ui/CustomSelect';
import moment from 'moment';
import UploadSKBloc from './Blocs/UploadSKBloc';

class IndexView extends Component {

    uploadSKBloc = new UploadSKBloc();
    
    queryParams = new URLSearchParams(window.location.search)

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {}
        }
    }

    dateParse = (input) =>{
      let res = "";
      if (input != "" && input != null){
        res = moment(input).format('DD/MM/YYYY')
      }
      return res;
    }

    dateParseYMD = (input) =>{
      let res = "";
      if (input != "" && input != null){
        res = moment(input).format('YYYY-MM-DD')
      }
      return res;
    }

    reformatOptions = (raw, label, value) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data[label];
          newObj["value"] = data[value];
      
          return newObj;
        });
    };

    submitData = async () => {
      const formData = generateFormData(this.state.dataForm, 'file_sk') // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
      await this.uploadSKBloc.fetchUploadSk(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values,
              uuid: this.state.dataForm.rank_history_uuid
            },
            confirm: true
        })
    } 

    rupiah = (num) => {
        let res = "-";
        if (num != null && num != ''){
            res = parseFloat(num).toLocaleString('id-ID', {maximumFractionDigits:2})
        }
        return res;
    }
  
    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {

        this.uploadSKBloc.uploadSkChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.uploadSKBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response

                        // load to form
                        this.setState({
                            dataForm: response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        
        this.uploadSKBloc.fetchDetail({ uuid: this.queryParams.get('uuid') })
    }

    componentWillUnmount(){
        this.uploadSKBloc.uploadSkChannel.unsubscribe()
        this.uploadSKBloc.detailChannel.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Upload SK Kenaikan Pangkat</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />

                                    
                                        <AvForm
                                            className="needs-validation"
                                            onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                        >

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor SK KP <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                 <AvField
                                                    name="rank_history_decree_number"
                                                    id="rank_history_decree_number"
                                                    placeholder="Nomor SK KP"
                                                    type="text"
                                                    errorMessage="Masukan Nomor SK KP"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.dataForm.rank_history_decree_number}
                                                />
                                            </Col>
                                        </Row>  

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal SK KP <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                 <AvField
                                                    name="rank_history_decree_date"
                                                    id="rank_history_decree_date"
                                                    placeholder="Tanggal SK KP"
                                                    type="date"
                                                    errorMessage="Masukan Tanggal SK KP"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.dateParseYMD(this.state.dataForm.rank_history_decree_date)}
                                                />
                                            </Col>
                                        </Row>    

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            TMT SK KP <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                 <AvField
                                                    name="rank_history_tmt_date"
                                                    id="rank_history_tmt_date"
                                                    placeholder="TMT SK KP"
                                                    type="date"
                                                    errorMessage="Masukan TMT SK KP"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.dateParseYMD(this.state.dataForm.rank_history_tmt_date)}
                                                />
                                            </Col>
                                        </Row>       


                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">Upload File SK KP</Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="file_sk"
                                                    col="2"
                                                />
                                            </Col>
                                        </Row>          
                                    
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to={`/kepegawaian/home.html?riwayat_pangkat`}>
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to={`/kepegawaian/home.html?riwayat_pangkat`}/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView